export class Bucket {
	bucketKey: number;
	businessKey: number;
	referenceId: string;
	displayName: string;
	isActive: boolean;
	consumerDisplayName: string;
}
